var _defs, _g, _path, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    viewBox: "0 0 30 30",
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 .996h7V7h-7Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.008 7.531h12.496v20.301H17.008Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 .996h7V7H3Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.484 10H11v13H.484Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.191 7.531h12.5v20.301h-12.5Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#48483e",
    d: "M23.477 3.96c0 1.638-1.34 2.966-2.985 2.966-1.652 0-2.988-1.328-2.988-2.965 0-1.637 1.336-2.965 2.988-2.965 1.645 0 2.985 1.328 2.985 2.965"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#48483e",
    d: "M23.629 20.3h-3.961c-1.035 0-1.887-.726-2.07-1.757l-1.188-7.594a.94.94 0 0 0-1.035-.754.932.932 0 0 0-.762 1.028l1.184 7.593c.308 1.907 1.922 3.27 3.871 3.27h3.992a.917.917 0 0 0 .914-.91c0-.516-.43-.875-.945-.875"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#48483e",
    d: "m29.477 26.2-1.586-8.657a1.367 1.367 0 0 0-1.34-1.117h-2.738l-.461-6.262a2.617 2.617 0 0 0-2.618-2.45h-.425c-.793 0-1.555.333-2.075.934-.515.606-.761 1.391-.636 2.18l1.125 7.203a1.347 1.347 0 0 0 1.34 1.149h5.363l1.37 7.535c.122.664.7 1.117 1.34 1.117.09 0 .153 0 .243-.027.762-.153 1.25-.848 1.098-1.606"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#48483e",
    d: "M9.46 3.96a2.974 2.974 0 0 1-2.98 2.966c-1.652 0-2.988-1.328-2.988-2.965C3.492 2.324 4.828.996 6.48.996a2.974 2.974 0 0 1 2.98 2.965"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#48483e",
    d: "M9.617 20.3H5.625c-1.035 0-1.887-.726-2.07-1.757l-1.192-7.594a.878.878 0 0 0-1.035-.754.929.929 0 0 0-.758 1.028l1.184 7.593c.308 1.907 1.922 3.27 3.871 3.27h3.992c.485 0 .91-.395.91-.91 0-.516-.425-.875-.91-.875"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#48483e",
    d: "M13.879 17.574a1.367 1.367 0 0 0-1.34-1.117H9.797l-.488-6.293a2.617 2.617 0 0 0-2.618-2.45h-.425a2.72 2.72 0 0 0-2.07.934c-.52.606-.766 1.391-.641 2.18l1.125 7.203a1.347 1.347 0 0 0 1.34 1.149h5.363l1.37 7.535c.122.664.7 1.117 1.34 1.117.09 0 .153 0 .243-.027.734-.121 1.254-.848 1.098-1.575l-1.555-8.656"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.7d2712fd3ffb6fc020a11acd8e09cd56.svg";
export { ForwardRef as ReactComponent };